<template>
  <div class="rateconfiguration">
    <div class="con">
      <div class="left-tree">
        <div class="search">
          <el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
        </div>
        <el-scrollbar style="height:calc(100% - 30px);width: 100%;">
          <el-tree :data="treeData" node-key="no" ref="tree" row-key="no" :props="defaultProps"
            :highlight-current="true" :default-expanded-keys="defaultExpanded" :current-node-key='defaultDevice'
            :expand-on-click-node="true" class="ut-custom-tree-list" @node-click="treeClick">
            <template slot-scope="{node}">

              <span style=" display: flex;align-items: center;">
                <img src="../../assets/rateTemplate/公司.png" style="margin-right:5px" />
                {{ node.data.unitName }}
                <img src="../../assets/rateTemplate/peizhi.png" v-if="node.data.temId" style="margin-left:5px">
              </span>
            </template>
          </el-tree>
        </el-scrollbar>
      </div>
      <div class="right-table">

        <div class="search-input-btn" style="width:100%">
          <div class="input-small">
            <span>名称：</span>
            <el-input v-model="searchName" clearable placeholder="请输入名称"></el-input>
          </div>
          <el-button type="primary" plain @click="searchFun" class="search-btn">查询</el-button>
          <el-button type="primary" class="search-btn" @click="getRateBindingUnitAndTemFun">绑定模板</el-button>
        </div>
        <div class="mytable">

          <el-table :max-height="heights" stripe
            :data=" temDate.filter((res) => !searchName || res.temName.includes(searchName))" border
            style="width: 100%">
            <template slot="empty">
              <span class="noData">
                <img src="@/assets/noData.png" alt="暂无数据">
                <span class="text">暂无数据</span>
              </span>
            </template>
            <el-table-column label="序号" width="60" align="center">
              <template slot-scope="scope">
                <span>{{ scope.$index + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column label="配置" width="180" align="center">
              <template slot-scope="scope">
                <input type="radio" name="zoom" :value="scope.$index" @change="getRadioVal(scope.$index)"
                  v-model="param" />
              </template>
            </el-table-column>

            <el-table-column prop="temName" label="模板名称"> </el-table-column>
            <el-table-column label="能源类型">
              <template slot-scope="scope"><span>{{ scope.row.energyType | energyType}}</span></template>
            </el-table-column>
            <el-table-column prop="intervalTotal" label="区间数量"> </el-table-column>



          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  // import axios from "axios";
  import { getRateData } from "../../api/rateTemplate";
  import { getRateTree, getRateBindingUnitAndTem } from "../../api/rateConfiguration";
  export default {
    data() {
      return {
        filterText: "",
        heights: document.getElementById('app').clientHeight - 205,//屏幕高度 - 导航栏高度
        facilityData: [],
        treeData: [
          {
            "unitId": "B5A693FA77804BC8BE009D57D0E7A788",
            "unitName": getName(),
            "no": 2,
            "parentNo": 0,
            "temId": 257055411572737,
            "children": [
              {
                "unitId": "d763e1dc1cbe45c497aa68db38f4acda",
                "unitName": "站点",
                "no": 12,
                "parentNo": 2,
                "temId": null,
                "children": null
              }
            ]
          }
        ], //树形结构数据
        defaultProps: {
          children: "children",
          unitName: "unitName",
        },
        searchName: "",//搜索框名称
        checked: true, // 查看全部按钮
        radio: 1, //表格单选按钮
        param: "", //默认选中
        temDate: [
          {
            "id": 302369042860033,
            "createUser": "1051231df55d44b38195318a54ce12ec",
            "createTime": 1700459010000,
            "updateTime": 1700459010000,
            "dataStatus": "ENABLE",
            "temName": "1",
            "energyType": "ELECTRIC",
            "intervalTotal": 2
          },
          {
            "id": 259552626448385,
            "createUser": "1051231df55d44b38195318a54ce12ec",
            "createTime": 1679552556000,
            "updateTime": 1679552556000,
            "dataStatus": "ENABLE",
            "temName": "越南模板",
            "energyType": "ELECTRIC",
            "intervalTotal": 2
          },
          {
            "id": 257055411572737,
            "createUser": "1051231df55d44b38195318a54ce12ec",
            "createTime": 1678333213000,
            "updateTime": 1678333213000,
            "dataStatus": "ENABLE",
            "temName": "越南模板1",
            "energyType": "ELECTRIC",
            "intervalTotal": 2
          },
          {
            "id": 253180517109761,
            "createUser": "1051231df55d44b38195318a54ce12ec",
            "createTime": 1676441175000,
            "updateTime": 1676441175000,
            "dataStatus": "ENABLE",
            "temName": "广东省通用模板",
            "energyType": "ELECTRIC",
            "intervalTotal": 1
          }
        ],//首页费率模板数据
        treeUnitNo: "", // 树形数据的no
        temId: "", //单选框选中模板id
        inputCheck: true, //查看全部复选框
        defaultExpanded: [],
        defaultDevice: ""
      };
    },
    methods: {
      //操作提醒
      operationFun(types, describe) {
        this.$message({
          type: types,
          message: describe,
          duration: 1500,
          offset: -150
        });
      },
      // 获取树形数据
      getRateTreeFun() {
        getRateTree().then(res => {
          if (res.code == 200) {
            this.treeData = res.data
            this.defaultExpanded = []
            this.defaultDevice = this.treeData[0].no
            this.defaultExpanded.push(this.treeData[0].no)
            this.$nextTick(() => {
              //默认选中
              this.$refs['tree'].setCurrentKey(this.defaultDevice);
              this.treeClick(this.treeData[0])
            })
          }
        })
      },
      // 费率模板数据
      getRateDataFun() {
        getRateData().then(data => {
          this.temDate = data.data
          this.getRateTreeFun() // 获取树形数据
        })
      },
      // 获取单选框
      getRadioVal(index) {
        this.temId = this.temDate[index].id
      },
      //查询
      searchFun() {
        //判断输入框是否为空
        if (this.searchName == '') {
          this.operationFun('warning', '输入框内容不能为空')
          return;
        }
        this.inputCheck = false
        getRateData({ temName: this.searchName }).then(data => {
          //  console.log("搜索",data);
          this.temDate = data.data
        })


      },
      //节点点击
      treeClick(a) {
        this.treeUnitNo = a.no
        if (a.temId) {
          //  this.temId = a.temId
          let index = this.temDate.findIndex(item => item.id == a.temId)
          this.param = index
        } else {
          this.param = ""
        }
      },

      // 点击绑定模板
      getRateBindingUnitAndTemFun() {
        if (this.temId == "" || this.treeUnitNo == "") {
          this.operationFun('error', '请选择模板')
          return

        }
        getRateBindingUnitAndTem({ temId: this.temId, unitNo: this.treeUnitNo }).then(data => {
          if (data.code == 200) {
            this.$message({ showClose: true, message: '绑定成功', type: 'success' });
            this.getRateTreeFun() // 获取树形数据
          }
        })
      }



    },
    created() {
      this.getRateDataFun() // 费率模板数据

    },
    watch: {
      //显示全部
      inputCheck(val) {
        if (val) {
          this.searchName = ""
          this.getRateDataFun();//费率模板数据
        }
      },
      filterText(val) {
        this.$refs.tree.filter(val);
      },
    },
    // 计算属性
    computed: {

    },
    //过滤器
    filters: {
      //费率类型 ELECTRIC(电)  WATER(水) GAS(气)
      energyType(val) {
        if (val == 'ELECTRIC') {
          return "电"
        } else if (val == 'WATER') {
          return "水"
        } else {
          return "气"
        }
      },
      // 转换时间戳
      "date_format": function (value) { //value就是插值的数据
        let date = new Date(value);
        let Y = date.getFullYear() + '-';
        let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
        let D = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate()) + ' ';

        let h = (date.getHours() < 10 ? '0' + (date.getHours()) : date.getHours()) + ':';
        let m = (date.getMinutes() < 10 ? '0' + (date.getMinutes()) : date.getMinutes()) + ':';
        let s = (date.getSeconds() < 10 ? '0' + (date.getSeconds()) : date.getSeconds());
        let strDate = Y + M + D + h + m + s;
        return strDate
      },
    }
  };
</script>

<style scoped lang="scss">
  .rateconfiguration {

    display: flex;

    .con {
      width: 100%;
      height: 100%;
      display: flex;
    }

    .left-tree {
      width: 300px;
      height: 100%;
      flex-shrink: 0;
      overflow: hidden;
      background-color: #fff;
      padding: 12px;
      box-sizing: border-box;
      margin-right: 8px;
    }

    .input-small span {
      white-space: nowrap;
    }

    .el_Tree_Body {
      border: 0px;
    }

    /deep/.search-input-btn .el-select .el-input__inner {
      width: 1.6rem;
    }

    .search-input-btn .input-small .el-input__inner {
      width: 1.6rem;
    }

    /deep/.search-input-btn .myinput .el-input {
      width: 1.6rem;
    }

    .right-table {
      width: calc(100% - 308px);
      background-color: #fff;
      padding: 2px 20px 12px 20px;
      box-sizing: border-box;

      .Files-table {


        /deep/.el-table th {
          background-color: #F3F8FF;
          color: #999999;
          border-right: 1px solid #E6E6E6;
          padding: 10px 0px;
          font-weight: bold;
        }

        /deep/.el-table td {
          padding: 1px 0px;
          height: 44px;
        }

        /deep/.el-table th.is-leaf {
          border-bottom: 0px;
        }

        .status {
          width: 8px;
          height: 8px;
          display: inline-block;
          border-radius: 50%;
          position: relative;
          top: -1px;
        }

        .state-row {
          display: flex;
          justify-content: center;
          align-items: center;

          span {
            display: inline-block;
            width: 9px;
            height: 9px;
            border-radius: 50%;
            margin-right: 10px;
            position: relative;
            top: -1px;
            border: 4px solid transparent;
          }
        }

        .open-state {
          color: #0DAE88;

          span {
            background-color: #0DAE88;
            border-color: #B0FFED;
          }
        }

        .close-state {
          color: #FF1D1D;

          span {
            background-color: #FF1D1D;
            border-color: #FFD7D7;
          }
        }

        .blue {
          background-color: #52A1FF;

        }

        .ash {
          background-color: #999999;

        }

        .buttoned_box {
          display: flex;
          justify-content: center;
          align-items: center;

          .line {
            display: inline-block;
            width: 1px;
            height: 20px;
            background-color: #E6E6E6;
            margin: 0px 20px;
          }

          .buttoned {
            cursor: pointer;
          }

          /deep/.el-button span {
            font-size: 15px;
            font-weight: 400;
          }
        }
      }

      .paging {
        display: flex;
        justify-content: flex-end;
        margin-top: 10px;
      }

    }

    /deep/.el-dialog__header {
      display: flex;
      align-items: center;
      border-bottom: 1px solid #E6E6E6;

      span {
        color: #67A3ED;
        font-size: 14px;
        font-weight: bold;
      }

      .el-icon-close {
        font-size: 20px !important;
      }

    }

    /deep/.el-dialog__footer {
      margin-top: 20px;
      text-align: right !important;
      border-top: 1px solid #E6E6E6;

      button {
        padding: 8px 17px;
      }
    }

    .demo-temp {
      display: flex;
      flex-wrap: wrap;
    }

    /deep/.el-form-item {
      display: flex;
      margin-left: 20px;
    }

    /deep/.el-form-item__label {
      white-space: nowrap;
      width: 86px;
    }

    /deep/.el-dialog__body {
      padding: 20px 0px 0px 20px !important;
    }

    .dialog {
      /deep/.el-input__inner {
        width: 217px;
      }
    }




  }
</style>